// packages import
import { FC, useContext } from 'react'

// component imports
import AttorneyDropdown from '../../../common/AttorneyDropdown'

// others
import { Maybe, User } from '../../../../../generated'
import { FinalBillsContext } from '../../../../context/FinalBillsContext'

const AttorneyFilter: FC = () => {
  const { filters, setFilters } = useContext(FinalBillsContext)

  const handleAttorneyChange = (value: Maybe<User>) => {
    setFilters({ attorneyId: value?.id })
  }

  return (
    <AttorneyDropdown
      selectedAttorneyId={filters.attorneyId}
      onChange={handleAttorneyChange}
      label="Attorney"
      sx={{ minWidth: 250 }}
    />
  )
}

export default AttorneyFilter
